// extracted by mini-css-extract-plugin
export default {"Tabs":"styles_Tabs__4PHG3","tab":"styles_tab__Eyqid","activeTab":"styles_activeTab__l9Nko"};